import { Inject, Injectable } from '@angular/core';
import { TBAppEnvironmentVars } from '@monorepo/types';

export const OrderUploadEndPoint = {
  GET_BCTX_LIST_SHIPPABLE_ID: '/api/v1/getBctxList/by/shippableUnitId',
  GET_BCTX_GROUP_AND_INDEPENDENT_BCTX_LIST_VERSIONED_ID: '/api/v1/getBctxGroupsAndIndependentBctxList/by/versionedId',
  GET_BCTX_GROUP_AND_INDEPENDENT_BCTX_LIST_BCTX_ITEMS: '/api/v1/getBctxGroupsAndIndependentBctxList/by/bctxItems',
  UPDATE_BCTX_GROUPS: '/api/v1/updateBctxGroups',
  UNGROUP_BY_VERSIONED_ID: '/api/v1/unGroup/by/versionedId',
  GET_BCTX_GROUP_LISTING: '/api/v1/bctxGroup/listing',
  SEARCH_BCTX: '/api/v1/bctxGroup/searchBctx',
};

@Injectable({ providedIn: 'root' })
export class OrderUploadEnvProvider {
  public protocol = 'http';
  public service_host = '';
  public factory_config_service = '';
  #API_URL: string;

  constructor(@Inject('environment') ENV: TBAppEnvironmentVars) {
    if (ENV.protocol != null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host != null) {
      this.service_host = ENV.service_host;
    }

    if (ENV.core_services != null) {
      this.factory_config_service = ENV.process_mapping_services;
    }
    this.#API_URL = this.protocol + this.service_host + this.factory_config_service;
  }

  public getUrlFromEnv(arg: keyof typeof OrderUploadEndPoint): string {
    return this.#API_URL + OrderUploadEndPoint[arg];
  }
}
